import type { UserRole } from '@/domain/roles'
import { ROLE_LABELS } from '@/domain/roles'

const ROLE_STYLES: Record<UserRole, string> = {
  individual_learner: 'bg-teal-500/15 text-teal-300 ring-1 ring-teal-500/30',
  school_student: 'bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30',
  teacher: 'bg-coral-500/15 text-coral-500 ring-1 ring-coral-500/30',
  corporate_employee: 'bg-teal-400/15 text-teal-300 ring-1 ring-teal-400/30',
  org_admin: 'bg-navy-700 text-teal-300 ring-1 ring-teal-500/30',
  super_admin: 'bg-amber-600/20 text-amber-400 ring-1 ring-amber-500/40',
}

export function RoleBadge({ role }: { role: UserRole }) {
  return <span className={`cyber-pill ${ROLE_STYLES[role]}`}>{ROLE_LABELS[role]}</span>
}
